import * as React from 'react';
export var Card = function (_a) {
    var children = _a.children;
    return (<div className='w-full h-full bg-white rounded-md shadow-md hover:shadow-lg p-4'>{children}</div>);
};
Card.displayName = 'UI.Card.Card';
export var DividedCard = function (_a) {
    var children = _a.children;
    return (<div className='w-full h-full bg-white rounded-md shadow-md hover:shadow-lg p-4 divide-y divide-gray-200'>
		{children}
	</div>);
};
DividedCard.displayName = 'UI.Card.DividedCard';
